export class UnexpectedError extends Error {
  constructor(message = 'Unexptected Error') {
    super(message);
  }
}
